import {Component, EventEmitter, Input, Output} from "@angular/core";
import {Slot} from "../../../../../../../../../../server/src/base/entities/leasing/calendar/Slot";
import {CalendarSlot} from "../../../../../../../entities/CalendarSlot";
import {CalendarDaySlot, CalendarTime} from "../../../../../../../entities/CalendarDaySlot";
import {IVanCalendar} from "../../../../../../../domain/leasing/IVanCalendar";

@Component({
    selector: 'leasing-userCalendar',
    styleUrls: ['./calendar.scss'],
    templateUrl: './calendar.html'
})
export class CalendarComponent {

    @Input() calendar:IVanCalendar;
    @Output() slotSelected:EventEmitter<Slot> = new EventEmitter<Slot>();
    @Output() slotUnSelected:EventEmitter<Slot> = new EventEmitter<Slot>();
    private selectedSlots:Array<Slot>;

    public currentMonth:string;
    public currentYear:number;
    public emptySlotsBefore:Array<CalendarSlot>;
    public emptySlotsAfter:Array<CalendarSlot>;

    ngOnInit(){
        this.Reset();
    }

    public Reset(slots:Array<Slot> = []){
        console.log('Reset');
        this.selectedSlots = [];
        if(slots.length > 0){
            this.SetSelectedSlots(slots);
        }else{
            this.Update();
        }
    }

    public SelectedSlots():Array<Slot> {
        return this.selectedSlots;
    }

    public SetSelectedSlots(slots:Array<Slot> = []){
        this.selectedSlots = slots;
        this.Update();
    }

    public nextMonth(){
        this.calendar.NextMonth();
        this.Update();
    }

    public previousMonth(){
        if(this.calendar.CurrentMonth().getTime() > new Date().getTime()){
            this.calendar.PreviousMonth();
            this.Update();
        }
    }

    public onSlotSelected(calendarSlot:CalendarSlot){
        if(this.selectedSlots.length == 0 || this.selectedSlots.length > 1){
            console.log('In selected range');
            this.Reset();
            this.SelectSlot(calendarSlot)
        }
        else{
            console.log('Not In selected range');
            this.ExtendRange(calendarSlot);
        }

        this.UpdateCalendarSlots();

        console.log(this.selectedSlots);
    }

    private UpdateCalendarSlots(){
        for(let slot of this.calendar.Slots()){
            for(let daySlot of slot.DaySlots()){
                daySlot.ResetSelection();
            }
        }

        for(let slot of this.GetCalendarSlotsFromSelectedSlots()){
            slot.Select();
        }
    }

    private GetCalendarSlotsFromSelectedSlots():Array<CalendarDaySlot>{
        let calendarDaySlots:Array<CalendarDaySlot> = [];
        for(let calendarSlot of this.calendar.Slots()){
            let slots = this.BuildSlotsFromCalendarSlot(calendarSlot);
            if(this.SelectedSlotsIncludes(slots[0])){
                calendarDaySlots.push(calendarSlot.DaySlots()[0])
            }
            if(this.SelectedSlotsIncludes(slots[1])){
                calendarDaySlots.push(calendarSlot.DaySlots()[1])
            }
        }
        console.log(calendarDaySlots);
        return calendarDaySlots;
    }

    private SelectedSlotsIncludes(slot:Slot):boolean{
        for(let selectedSlot of this.selectedSlots){
            if(slot.Equals(selectedSlot)){
                return true;
            }
        }
        return false;
    }

    private ExtendRange(calendarSlot:CalendarSlot){
        let selectedSlot = this.GetClickedSlotFromCalendarSlot(calendarSlot);
        let firstSlot = this.FirstSelectedSlot();
        let lastSlot = this.LastSelectedSlot();
        if(selectedSlot.IsBefore(this.FirstSelectedSlot())){
            let newSlots = this.RemoveTakenSlots(this.GetSlotsBetween(selectedSlot, firstSlot.Previous()));
            this.selectedSlots = this.selectedSlots.concat(newSlots);
        }
        else{
            let newSlots = this.RemoveTakenSlots(this.GetSlotsBetween(lastSlot.Next(), selectedSlot));
            this.selectedSlots = this.selectedSlots.concat(newSlots);
        }
    }

    private RemoveTakenSlots(slots:Array<Slot>):Array<Slot>{
        let slotsToReturn = [];
        for(let slot of slots){
            if(this.calendar.CalendarSlot(slot).Available()){
                slotsToReturn.push(slot);
            }
        }
        return slotsToReturn;
    }

    private GetSlotsBetween(firstSlot:Slot, lastSlot:Slot):Array<Slot>{
        console.log("Between");
        let slots:Array<Slot> = [];
        while(!firstSlot.Equals(lastSlot)){
            console.log("Blocked");
            slots.push(firstSlot);
            firstSlot = firstSlot.Next();
        }
        slots.push(firstSlot);
        return slots;
    }

    private IsInSelectedRange(calendarSlot:CalendarSlot):boolean{
        let selectedSlot = this.GetClickedSlotFromCalendarSlot(calendarSlot);
        let firstSlot = this.FirstSelectedSlot();
        let lastSlot = this.LastSelectedSlot();
        if(selectedSlot.Equals(firstSlot) || selectedSlot.Equals(lastSlot)){
            return true;
        }
        return selectedSlot.IsAfter(firstSlot) && selectedSlot.IsBefore(lastSlot);
    }

    private FirstSelectedSlot():Slot{
        let firstSlot:Slot = this.selectedSlots[0];
        for(let slot of this.selectedSlots){
            if(slot.IsBefore(firstSlot)){
                firstSlot = slot;
            }
        }
        return firstSlot;
    }

    private LastSelectedSlot():Slot{
        let lastSlot:Slot = this.selectedSlots[0];
        for(let slot of this.selectedSlots){
            if(slot.IsAfter(lastSlot)){
                lastSlot = slot;
            }
        }
        return lastSlot;
    }

    private SelectSlot(calendarSlot:CalendarSlot){
        console.log('Select slot');
        let slot = this.GetClickedSlotFromCalendarSlot(calendarSlot);
        this.selectedSlots.push(slot);
        this.slotSelected.emit(slot);
    }

    public onSlotRemoved(calendarSlot:CalendarSlot){
        let slotsToRemove:Array<number> = [];
        let index:number = 0;
        let removedSlot:Slot;
        for(let selectedSlot of this.selectedSlots){
            let slot = this.GetClickedSlotFromCalendarSlot(calendarSlot);
            if(selectedSlot.Equals(slot)){
                slotsToRemove.push(index);
                removedSlot = slot;
            }
            index++;
        }
        this.RemoveSlotsAtIndexes(slotsToRemove);
        this.slotUnSelected.emit(removedSlot);
    }

    private RemoveSlotsAtIndexes(indexes:Array<number>){
        let newSelectedSlots:Array<Slot> = [];
        for(let i = 0 ; i < this.selectedSlots.length; ++i){
            if(!indexes.includes(i)){
                newSelectedSlots.push(this.selectedSlots[i]);
            }
        }
        this.selectedSlots = newSelectedSlots;
    }

    private BuildSlotsFromCalendarSlot(slot:CalendarSlot):Array<Slot>{
        let slots:Array<Slot> = [];
        for(let daySlot of slot.DaySlots()){
            let date:Date = new Date(this.calendar.CurrentMonth());
            date.setDate(slot.Day());
            if(daySlot.Time() === CalendarTime.AM){
                date.setHours(1);
            }else{
                date.setHours(13);
            }
            slots.push(new Slot(date));
        }
        return slots;
    }

    private GetClickedSlotFromCalendarSlot(slot:CalendarSlot):Slot{
        for(let daySlot of slot.DaySlots()){
            if(daySlot.Clicked()){
                let date:Date = new Date(this.calendar.CurrentMonth());
                date.setDate(slot.Day());
                if(daySlot.Time() === CalendarTime.AM){
                    date.setHours(1);
                }else{
                    date.setHours(13);
                }
                return new Slot(date);
            }
        }
    }

    private Update(){
        this.ComputeMonthString();
        this.ComputeCurrentYear();
        this.ComputeEmptySlotsBefore();
        this.ComputeEmptySlotsAfter();

        var that = this;
        setTimeout(() => {
            that.HighlightSelectedSlots();
        }, 100);
    }

    private HighlightSelectedSlots(){
        for(let slot of this.selectedSlots){
            if(this.IsSlotInCurrentMonth(slot)){
                for(let calendarSlot of this.calendar.Slots()){
                    if(calendarSlot.Day() == slot.Date().getDate()){
                        if(slot.Date().getHours() < 13){
                            calendarSlot.DaySlots()[0].Select();
                        }else{
                            calendarSlot.DaySlots()[1].Select();
                        }
                        break;
                    }
                }
            }
        }
    }

    private IsSlotInCurrentMonth(slot:Slot):boolean{
        return (slot.Date().getFullYear() == this.calendar.CurrentMonth().getFullYear()) &&
            (slot.Date().getMonth() == this.calendar.CurrentMonth().getMonth());
    }

    private ComputeEmptySlotsBefore(){
        this.emptySlotsBefore = [];
        let nbEmptyDays:number = this.calendar.FirstDayOfTheMonth() - 1;
        if(nbEmptyDays < 0){
            nbEmptyDays = 6;
        }

        let previousMonth = new Date(this.calendar.CurrentMonth());
        previousMonth.setDate(0);
        let nbDaysPreviousMonth = previousMonth.getDate();
        for(let i = nbEmptyDays ; i > 0; --i){
            this.emptySlotsBefore.push(new CalendarSlot((nbDaysPreviousMonth - i) + 1));
        }
    }

    private ComputeEmptySlotsAfter(){
        this.emptySlotsAfter = [];
        let totalSlots:number = 42;
        let nbEmptyDays = totalSlots - (this.calendar.Slots().length + this.emptySlotsBefore.length);

        for(let i = 0 ; i < nbEmptyDays; ++i){
            this.emptySlotsAfter.push(new CalendarSlot(i + 1));
        }
    }

    private ComputeCurrentYear(){
        this.currentYear = this.calendar.CurrentMonth().getFullYear();
    }

    private ComputeMonthString(){
        switch (this.calendar.CurrentMonth().getMonth()){
            case 0:
                this.currentMonth = "Janvier";
                break;
            case 1:
                this.currentMonth = "Février";
                break;
            case 2:
                this.currentMonth = "Mars";
                break;
            case 3:
                this.currentMonth = "Avril";
                break;
            case 4:
                this.currentMonth = "Mai";
                break;
            case 5:
                this.currentMonth = "Juin";
                break;
            case 6:
                this.currentMonth = "Juillet";
                break;
            case 7:
                this.currentMonth = "Aout";
                break;
            case 8:
                this.currentMonth = "Septembre";
                break;
            case 9:
                this.currentMonth = "Octobre";
                break;
            case 10:
                this.currentMonth = "Novembre";
                break;
            case 11:
                this.currentMonth = "Décembre";
                break;
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/leasing/presentation/userReservation/calendar/calendar.ts